var chunkToChildrenMap = {
	"8415": [
		8452,
		4238,
		2503,
		1308,
		9765,
		543,
		8385,
		8533,
		4649,
		3021
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));